'use client';

import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as", "listStyleReset", "condensed", "variant", "weight", "className"];
import React from 'react';
import { ENCORE_DATA_IDS } from "../../dataEncoreIds.mjs";
import { Text } from "../Text/index.mjs";
import { warnLegacyTypeVariant } from "../../logging.mjs";
import { ecx, mapLegacyToTextVariant } from "../../utils.mjs";
/**
 * TypeListItem is an individual unit in the TypeList component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-typelist-typelistitem--docs) |
 * [Encore site](https://encore.spotify.net/web/components/text#text-lists) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/TypeListItem)
 */
export var TypeListItem = /*#__PURE__*/React.forwardRef(function TypeListItem(_ref, ref) {
  var _ref$as = _ref.as,
    as = _ref$as === void 0 ? 'li' : _ref$as,
    _ref$listStyleReset = _ref.listStyleReset,
    listStyleReset = _ref$listStyleReset === void 0 ? false : _ref$listStyleReset,
    condensed = _ref.condensed,
    variant = _ref.variant,
    weight = _ref.weight,
    className = _ref.className,
    props = _objectWithoutProperties(_ref, _excluded);
  if (variant) warnLegacyTypeVariant('TypeListItem', variant, weight);
  return /*#__PURE__*/React.createElement(Text, Object.assign({
    className: ecx(['type-list-item', 'baseline', {
      'type-list-item--condensed': condensed,
      'type-list-item--unstyled': listStyleReset
    }], className)
  }, props, {
    ref: ref,
    as: as,
    variant: variant && mapLegacyToTextVariant(variant, weight),
    "data-encore-id": ENCORE_DATA_IDS.TypeListItem
  }));
});